export const LOAD_EXCHANGE_INFO = 'LOAD_EXCHANGE_INFO';
export const GET_EXCHANGE_SETTINGS = 'GET_EXCHANGE_SETTINGS';
export const EDIT_EXCHANGE_ACTIVE = 'EDIT_EXCHANGE_ACTIVE';
export const EDIT_EXCHANGE_MIN_AMOUNT = 'EDIT_EXCHANGE_MIN_AMOUNT';
export const EDIT_EXCHANGE_MAX_AMOUNT = 'EDIT_EXCHANGE_MAX_AMOUNT';
export const EDIT_EXCHANGE_PAYMENT_SYSTEM = 'EDIT_EXCHANGE_PAYMENT_SYSTEM';
export const CHANGE_EXCHANGE_ONLINE_STATUS = 'CHANGE_EXCHANGE_ONLINE_STATUS';
export const LOAD_BLACK_LIST_USERS = 'LOAD_BLACK_LIST';
export const ADD_BLACK_LIST_USER = 'ADD_BLACK_LIST_USER';
export const DELETE_BLACK_LIST_USER = 'DELETE_BLACK_LIST_USER';
export const LOAD_BLACK_LIST_REQUISITES = 'LOAD_BLACK_LIST_REQUISITES';
export const ADD_BLACK_LIST_REQUISITE = 'ADD_BLACK_LIST_REQUISITE';
export const DELETE_BLACK_LIST_REQUISITE = 'DELETE_BLACK_LIST_REQUISITE';
export const RESET_EXCHANGE = 'RESET_EXCHANGE';
export const LOAD_INTERBANKS = 'LOAD_INTERBANKS';
export const LOAD_QR_INTERBANKS = 'LOAD_QR_INTERBANKS';
export const ENABLE_INTERBANK = 'ENABLE_INTERBANK';
export const DISABLE_INTERBANK = 'DISABLE_INTERBANK';
export const EDIT_TRAFFIC_SPILL_AMOUNT = 'EDIT_TRAFFIC_SPILL_AMOUNT';
export const ENABLE_TRAFFIC_SPILL = 'ENABLE_TRAFFIC_SPILL';
export const DISABLE_TRAFFIC_SPILL = 'DISABLE_TRAFFIC_SPILL';
export const EDIT_INTERBANK_RATE_PERCENT = 'EDIT_INTERBANK_RATE_PERCENT';
export const LOAD_EXCHANGE_STATS = 'LOAD_EXCHANGE_STATS';
export const LOAD_BANKS_LIST = 'LOAD_BANKS_LIST';
